/** 全屏遮罩/弹窗统一 z-index，需高于侧边栏(20)和移动端遮罩(999)，保证覆盖整页 */
export const OVERLAY_Z_INDEX = 10000;

// 平台占位符等静态配置；档案「音乐/社交」归类以平台配置 API + platformLinkBuckets 为准
export const PLATFORM_CONFIG = {
  'qq-music': { placeholder: 'https://i.y.qq.com/...' },
  'netease': { placeholder: 'https://music.163.com/...' },
  'spotify': { placeholder: 'https://open.spotify.com/...' },
  'apple-music': { placeholder: 'https://music.apple.com/...' },
  'kugou': { placeholder: 'https://www.kugou.com/singer/info/...' },
  'kuwo': { placeholder: 'https://www.kuwo.cn/singer_detail/...' },
  'migu': { placeholder: 'https://music.migu.cn/v5/#/singerDetail?id=...' },
  'weibo': { placeholder: 'https://weibo.com/...' },
  'xiaohongshu': { placeholder: 'https://www.xiaohongshu.com/...' },
  'douyin': { placeholder: 'https://www.douyin.com/...' },
  'bilibili': { placeholder: 'https://space.bilibili.com/...' },
} as const;

export const ALL_PLATFORM_OPTIONS = [
  { value: 'qq-music', label: 'QQ音乐', type: 'music' },
  { value: 'netease', label: '网易云音乐', type: 'music' },
  { value: 'spotify', label: 'Spotify', type: 'music' },
  { value: 'apple-music', label: 'Apple Music', type: 'music' },
  { value: 'kugou', label: '酷狗音乐', type: 'music' },
  { value: 'kuwo', label: '酷我音乐', type: 'music' },
  { value: 'migu', label: '咪咕音乐', type: 'music' },
  { value: 'weibo', label: '微博', type: 'social' },
  { value: 'xiaohongshu', label: '小红书', type: 'social' },
  { value: 'douyin', label: '抖音', type: 'social' },
  { value: 'bilibili', label: 'B站', type: 'social' },
] as const; 